package br.com.texeratx.boardgametimeapp.ui.screens.stats

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.getScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow

class StatsScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val vm = getScreenModel<StatsViewModel>()
        val state by vm.state.collectAsState()

        LaunchedEffect(Unit) {
            // carrega a aba default (Global)
            if (state.global == null) vm.loadGlobal()
        }

        StatsUI(
            state = state,
            onBack = { navigator.pop() },
            onSelectTab = { tab ->
                vm.selectTab(tab)
                when (tab) {
                    StatsTab.Global -> if (state.global == null) vm.loadGlobal()
                    StatsTab.Year -> if (state.yearHistory == null) vm.loadYear(state.selectedYear)
                    StatsTab.Duration -> if (state.durationStats.isEmpty()) vm.loadDuration()
                }
            },
            onSetYear = vm::setYear
        )
    }
}


